export default __webpack_public_path__ + "82ef56ad4d49ae46808c48a58b07d4f3.png";